<template>
  <div class="container">
    <h1>Company Membership</h1>
    <p>
      You can join the <strong>{{ $store.state.tenant.subdomain }}</strong> organization as a member (e.g. as a Listing Agent or an Administrator) via this page.
    </p>
    <p>
      To do this you should have received an invitation token via email.
      Enter the token to the input field below (unless it's already prefilled for you) and click the join button.
    </p>
    <p v-if="!$store.state.user.idToken">
      <v-icon color="red">report_problem</v-icon> You need to first sign up / login to complete this process.
    </p>
    <form ref="joinForm">
      <fieldset>
        <label for="token">Token</label>
        <input v-model="token" id="token" type="text" required />
      </fieldset>
      <fieldset>
        <button @click.prevent="join">Join</button>
      </fieldset>
    </form>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        token: this.$route.params.token
      }
    },
    mounted() {
      if (!this.$store.state.user.idToken) {
        this.$store.commit('openSignUpDialog')
      }
    },
    methods: {
      join() {
        if (!this.$refs.joinForm.checkValidity()) {
          this.$refs.joinForm.reportValidity()
          return
        }
        if (!this.$store.state.user.idToken) {
          this.$store.commit('openSignUpDialog')
          return
        }
        let notificationText = ''
        this.$PfxBackendApi.joinTenant(this.token).then((res) => {
          console.log('joinTenant res', res)
          this.$store.dispatch('reloadTenantRole')
          notificationText = 'Well done! Now fill in some profile data.'
          this.token = null
        }).catch(err => {
          console.error('joinTenant err', err)
          notificationText = 'Failed: '
          switch (err.status) {
            case 401: {
              notificationText += 'You need to sign up / login before joining.'
              break
            }
            case 404: {
              notificationText += 'Invalid token. Contact broker.'
              break
            }
            case 409: {
              notificationText += 'Account exists already.'
              break
            }
            default: {
              notificationText += 'Unexpected error. Try again after a while.'
            }
          }
        }).then(() => {
          this.$store.commit('openDialog', {
            title: 'Notification',
            text: notificationText,
            buttons: [
              {
                title: 'Close this',
                handler: () => {
                  this.$store.commit('closeDialog')
                  if (this.token === null) {
                    this.$router.push('/profile')
                  }
                }
              }
            ]
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/JoinPage.vue